import { MyTripsFilter } from "redmond";

export const getTabs = (
  tripsFilter: MyTripsFilter,
  tabs: { label: MyTripsFilter }[]
) => {
  const filteredTabs = tabs.filter((tab) => {
    if (tab.label === MyTripsFilter.TRIPS_WITH_OFFERS) {
      return tripsFilter === MyTripsFilter.TRIPS_WITH_OFFERS;
    }
    return true;
  });

  return filteredTabs;
};
